<template>
	<div class="the_aside">
		<el-menu 
			:default-active="$route.path"
			class="nav_menu"
			background-color="#fff"
			text-color="#666"
			active-text-color="#fff"
			router>
			<el-menu-item index="/admin/home">
				<i class="el-icon-s-home"></i>
				<span slot="title">首页</span>
			</el-menu-item>
			<el-submenu index="account">
				<template slot="title">
					<i class="el-icon-s-custom"></i>
					<span slot="title">账号管理</span>
				</template>
				<el-menu-item index="/admin/account-manage">账号信息</el-menu-item>
			</el-submenu>
			<el-submenu index="business">
				<template slot="title">
					<i class="el-icon-coordinate"></i>
					<span slot="title">业务管理</span>
				</template>
				<el-menu-item index="/admin/node-register">节点注册</el-menu-item>
				<el-menu-item index="/admin/node-manage">节点查询</el-menu-item>
			</el-submenu>
		</el-menu>
	</div>
</template>
<script>
	export default{
		name:'Aside',
		data(){
			return{
				menuList:[//菜单列表
					// {
					// 	title:'导航一',
					// 	path:'1',
					// 	icon:'el-icon-location',
					// 	children:[
					// 		{
					// 			title:'选项一',
					// 			path:'1-1',
					// 			children:[]
					// 		},
					// 		{
					// 			title:'选项二',
					// 			path:'1-2',
					// 			children:[
					// 				{
					// 					title:'三级菜单',
					// 					path:'1-2-1',
					// 				},{
					// 					title:'四级菜单',
					// 					path:'1-2-2',
					// 				}
					// 			]
					// 		}
					// 	]
					// },
					// {
					// 	title:'导航二',
					// 	path:'2',
					// 	icon:'el-icon-menu',
					// 	children:[]
					// },
					{
						title:'示例',
						path:'/demo',
						icon:'el-icon-location',
						children:[
							{
								title:'接口示例',
								path:'/demo/api',
								children:[]
							},
							{
								title:'表格',
								path:'table',
								children:[
									{
										title:'通用表格列表',
										path:'/demo/list',
									}
								]
							}
						]
					},{
						title:'模板',
						path:'/temp',
						icon:'el-icon-edit-outline',
						children:[]
					},{
						title:'练习',
						path:'/test',
						icon:'el-icon-edit-outline',
						children:[]
					},{
						title:'特效',
						path:'/animate',
						icon:'el-icon-magic-stick',
						children:[]
					},{
						title:'组件',
						path:'/plugins',
						icon:'el-icon-s-grid',
						children:[]
					},{
						title:'echarts图表',
						path:'/echarts',
						icon:'el-icon-s-grid',
						children:[{
							title:'折线图',
							path:'line',
							children:[
								{
									title:'基础折线图',
									path:'/echarts/line',
								},
							]
						},{
							title:'饼图',
							path:'pie',
							children:[
								{
									title:'基础饼图',
									path:'/echarts/pie',
								},
							]
						},{
							title:'柱状图',
							path:'bar',
							children:[
								{
									title:'基础柱状图',
									path:'/echarts/bar',
								},
							]
						}]
					}
				],
				// selectIndex:'/admin/home',//当前选中菜单
			}
		},
		mounted(){
			// this.menuList=this.$store.state.globalData
		},
		methods:{
		}
	}
</script>
<style lang='scss' scoped>
	.the_aside{
		width: 270px;
		flex: none;
		overflow-x: hidden;
		box-sizing: border-box;
		background-color: #fff;
		overflow: auto;
		border-top: 1px solid rgba(204,204,204,0.5);
		box-shadow: 0px 0px 6px 0px rgba(204,204,204,0.5);
		.nav_menu{
			::v-deep {.el-submenu__title{
				padding-left: 60px !important;
			}
		}
		::v-deep {.el-menu-item{
				padding-left: 60px !important;
			}
		}
			.is-active{
				background-color: #00AA73 !important;
			}
			.el-submenu{
				// padding: 0 20px;
				// box-sizing: border-box;
				::v-deep {.el-menu{
					background-color: #E9F6F2 !important;
					.el-menu-item{
						padding-left: 100px !important;
						background-color: transparent !important;
					}
				}
			}
				.is-active{
					color: #00AA73 !important;
				}
			}
			.el-submenu.is-active{
				::v-deep {.el-submenu__title{
					background-color: #00AA73 !important;
					color: #fff !important;
				}
			}
				i {
					color: #fff !important;
				}
			}
			// .el-submenu.is-opened{
			// ::v-deep {.el-submenu__title{
			// 		background-color: #00AA73 !important;
			// 		color: #fff !important;
			// 	}
		// }
			// }
			::v-deep {.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
				color: #fff;
			}
		}
		}
	}
	::-webkit-scrollbar {
		display: none;
	}
	.el-menu{
		border-right-width: 0;
	}
</style>